import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFProductWinAdd from '@/components/UI/svg/mm100/Icon/EFProductWinAdd';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/pc/');

export default function Comp({ callBack }: any) {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const { locale } = useRouter();
    const imgLocal = getImageLocal(locale, ['cn']);

    return (
        <div className={`${css.listD} listD2`}>
            <div className="kit-inter">
                <div className="kit-ms1">{t('presale.product.listD2_ms1')}</div>
                <div className="kit-ms2">{t('presale.product.listD2_ms2')}</div>
                <div className="kit-ms3">{t('presale.product.listD2_ms3')}</div>
                <div className="more-win-fun more-win-fun1" onClick={() => callBack('modal-listD2')}>
                    {t('presale.product.listD2_btn1')}
                    <span className="more-win-fun-icon">
                        <EFProductWinAdd />
                    </span>
                </div>
                {!['de', 'fr', 'it', 'es'].includes(locale) && (
                    <div className="kit-img">
                        <EFPic name={[`listD2_${imgLocal}.webp`, `listD2_${imgLocal}.jpg`]} className="fullImgs" alt={t('presale.product.listD2_ms1')} />
                    </div>
                )}
                {['de', 'fr', 'it', 'es'].includes(locale) && (
                    <div className="kit-img">
                        <EFPic name={[`listD2_${locale}.webp`, `listD2_${locale}.jpg`]} className="fullImgs" alt={t('presale.product.listD2_ms1')} />
                    </div>
                )}
            </div>
        </div>
    );
}
